/* ============================================================
   VISION THEME — JS ENGINE
   Drawers, cart AJAX, predictive search, hero carousel,
   variants, quick add, wishlist, reveals, accordions.
   No dependencies. Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var T = window.Theme || {};
  var strings = T.strings || {};
  var settings = T.settings || {};
  var routes = T.routes || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = T.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    var withComma = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noCents = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noCentsComma = noCents.replace(/,/g, '.');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noCentsComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noCents)
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  function toast(msg, isError) {
    var box = $('[data-toast-container]');
    if (!box) return;
    var el = document.createElement('div');
    el.className = 'toast' + (isError ? ' toast--error' : '');
    el.textContent = msg;
    box.appendChild(el);
    setTimeout(function () { el.style.opacity = '0'; el.style.transition = 'opacity .3s'; }, 2600);
    setTimeout(function () { el.remove(); }, 3000);
  }

  function trapFocus(container) {
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return function () {};
    var first = focusables[0], last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- Drawer / modal manager ---------- */
  var DrawerManager = {
    active: null,
    releaseFocus: null,
    overlay: null,
    init: function () {
      this.overlay = $('[data-overlay]');
      var self = this;
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
    },
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      this.close();
      this.active = el;
      el.classList.add('is-open');
      document.body.classList.add('drawer-open');
      if (this.overlay) this.overlay.classList.add('is-visible');
      this.releaseFocus = trapFocus(el);
      var input = $('[data-search-input]', el);
      setTimeout(function () { (input || el).focus && (input ? input.focus() : el.focus()); }, 350);
      if (id === 'cart-drawer') CartAPI.refreshDrawer(false);
      var btn = document.querySelector('[data-open-drawer="' + id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    },
    close: function () {
      if (!this.active) return;
      this.active.classList.remove('is-open');
      $$('[data-open-drawer]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('drawer-open');
      if (this.overlay) this.overlay.classList.remove('is-visible');
      if (this.releaseFocus) this.releaseFocus();
      this.active = null;
    }
  };
  DrawerManager.init();

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-open-drawer]'))) { e.preventDefault(); DrawerManager.open(t.getAttribute('data-open-drawer')); return; }
    if ((t = e.target.closest('[data-close-drawer]'))) { DrawerManager.close(); return; }
    if ((t = e.target.closest('[data-close-modal]'))) { Modal.close(); return; }

    /* Accordions */
    if ((t = e.target.closest('[data-accordion-toggle]'))) {
      var item = t.closest('[data-accordion]');
      var content = $('[data-accordion-content]', item);
      var open = item.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open);
      content.style.maxHeight = open ? content.scrollHeight + 'px' : '0px';
      return;
    }

    /* Mobile submenu */
    if ((t = e.target.closest('[data-submenu-toggle]'))) {
      var li = t.closest('.mobile-menu__item');
      var sub = $('.mobile-menu__sub', li);
      var isOpen = li.classList.toggle('is-open');
      t.setAttribute('aria-expanded', isOpen);
      if (sub) sub.style.maxHeight = isOpen ? sub.scrollHeight + 'px' : '0px';
      return;
    }

    /* Footer mobile accordions */
    if ((t = e.target.closest('[data-footer-toggle]'))) {
      if (window.innerWidth > 749) return;
      var col = t.closest('.footer-col');
      var fc = $('.footer-col__content', col);
      var fOpen = col.classList.toggle('is-open');
      t.setAttribute('aria-expanded', fOpen);
      if (fc) fc.style.maxHeight = fOpen ? fc.scrollHeight + 'px' : '';
      return;
    }

    /* Quantity +/- inside cart rows */
    if ((t = e.target.closest('[data-qty-minus], [data-qty-plus]'))) {
      var row = t.closest('[data-cart-item]');
      var input = t.closest('.qty-selector').querySelector('[data-qty-input]');
      var next = parseInt(input.value || '1', 10) + (t.hasAttribute('data-qty-plus') ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      if (row && row.dataset.key) CartAPI.change(row.dataset.key, next);
      return;
    }
    if ((t = e.target.closest('[data-cart-remove]'))) {
      var r2 = t.closest('[data-cart-item]');
      if (r2 && r2.dataset.key) CartAPI.change(r2.dataset.key, 0);
      return;
    }

    /* Quick add */
    if ((t = e.target.closest('[data-quick-add]'))) { e.preventDefault(); QuickAdd.open(t.getAttribute('data-handle')); return; }

    /* Wishlist */
    if ((t = e.target.closest('[data-wishlist-toggle]'))) { e.preventDefault(); Wishlist.toggle(t.getAttribute('data-handle'), t); return; }

    /* Collection filters drawer (mobile) */
    if ((t = e.target.closest('[data-open-filters]'))) { var f = $('#collection-filters'); if (f) { f.classList.add('is-open'); document.body.classList.add('drawer-open'); if (DrawerManager.overlay) DrawerManager.overlay.classList.add('is-visible'); } return; }
    if ((t = e.target.closest('[data-close-filters]'))) { var f2 = $('#collection-filters'); if (f2) { f2.classList.remove('is-open'); document.body.classList.remove('drawer-open'); if (DrawerManager.overlay) DrawerManager.overlay.classList.remove('is-visible'); } return; }
  });

  /* Filter auto-submit (checkbox change) */
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-filter-form]') && e.target.type === 'checkbox') {
      e.target.closest('form').submit();
    }
    if (e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    if (e.target.matches('[data-cart-item] [data-qty-input]')) {
      var row = e.target.closest('[data-cart-item]');
      if (row && row.dataset.key) CartAPI.change(row.dataset.key, parseInt(e.target.value, 10) || 0);
    }
  });

  /* ---------- Cart API ---------- */
  var CartAPI = {
    add: function (variantId, qty, done) {
      fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        toast(strings.addedToCart || 'Added to cart');
        CartAPI.refreshDrawer(true);
        if (done) done();
      })
      .catch(function (err) {
        toast((err && err.description) || strings.cartError || 'Could not add to cart', true);
        if (done) done(err);
      });
    },
    change: function (key, qty) {
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CartAPI.syncCounts(cart);
        CartAPI.refreshDrawer(DrawerManager.active && DrawerManager.active.id === 'cart-drawer');
        var subs = $$('[data-cart-subtotal]');
        subs.forEach(function (s) { s.textContent = formatMoney(cart.total_price); });
      })
      .catch(function () { toast(strings.cartError || 'Error', true); });
    },
    refreshDrawer: function (openAfter) {
      fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#cart-drawer .cart-drawer__content');
          var current = $('#cart-drawer .cart-drawer__content');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          CartAPI.fetchCart();
          if (openAfter) DrawerManager.open('cart-drawer');
        })
        .catch(function () {});
    },
    fetchCart: function () {
      fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(CartAPI.syncCounts).catch(function () {});
    },
    syncCounts: function (cart) {
      if (!cart) return;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count; });
      CartAPI.updateShippingProgress(cart);
    },
    updateShippingProgress: function (cart) {
      if (!settings.freeShippingEnabled) return;
      var wrap = $('[data-shipping-progress]');
      if (!wrap) return;
      var threshold = parseInt(wrap.getAttribute('data-threshold'), 10) || settings.freeShippingThreshold;
      var remaining = threshold - cart.total_price;
      var msg = $('[data-shipping-message]', wrap);
      var bar = $('[data-shipping-bar]', wrap);
      if (bar) bar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      if (msg) {
        if (remaining <= 0) {
          wrap.classList.add('is-complete');
          msg.textContent = settings.freeShippingSuccess;
        } else {
          wrap.classList.remove('is-complete');
          var parts = (settings.freeShippingMessage || 'Add [amount] more for FREE DELIVERY').split('[amount]');
          msg.innerHTML = (parts[0] || '') + '<strong data-shipping-remaining>' + formatMoney(remaining) + '</strong>' + (parts[1] || '');
        }
      }
    }
  };

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-search-input]');
  if (searchInput) {
    var resultsBox = $('[data-search-results]');
    var doSearch = debounce(function (q) {
      if (!q || q.length < 2) { resultsBox.innerHTML = ''; return; }
      if (!settings.predictiveEnabled) return;
      resultsBox.innerHTML = '<p class="search-drawer__status">' + (strings.searching || 'Searching...') + '</p>';
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product' + (settings.predictiveShowPrice !== undefined ? '' : '') + ',collection';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          resultsBox.innerHTML = doc.body.innerHTML || '<p class="search-drawer__status">' + strings.noResults + '</p>';
        })
        .catch(function () { resultsBox.innerHTML = '<p class="search-drawer__status">' + (strings.cartError || 'Error') + '</p>'; });
    }, 250);
    searchInput.addEventListener('input', function () { doSearch(this.value.trim()); });
    var searchForm = $('[data-search-form]');
    if (searchForm) searchForm.addEventListener('submit', function () { DrawerManager.close(); });
  }

  /* ---------- Announcement bar ---------- */
  var ann = $('[data-announcement]');
  if (ann) {
    var slides = $$('[data-ann-slide]', ann);
    var idx = 0, timer = null;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
    }
    function start() {
      if (ann.getAttribute('data-autorotate') !== 'true' || slides.length < 2) return;
      timer = setInterval(function () { show(idx + 1); }, parseInt(ann.getAttribute('data-speed'), 10) || 5000);
    }
    function stop() { clearInterval(timer); }
    var prev = $('[data-ann-prev]', ann), next = $('[data-ann-next]', ann), closeBtn = $('[data-ann-close]', ann);
    if (prev) prev.addEventListener('click', function () { stop(); show(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); show(idx + 1); start(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { ann.classList.add('is-closed'); try { sessionStorage.setItem('ann-closed', '1'); } catch (e) {} });
    try { if (sessionStorage.getItem('ann-closed') === '1') ann.classList.add('is-closed'); } catch (e) {}
    start();
  }

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Hero carousel ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-hero-track]', hero);
    var heroSlides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-dot]', hero);
    if (heroSlides.length < 2) { heroSlides[0] && heroSlides[0].classList.add('is-active'); return; }
    var current = 0, timer = null;
    var isFade = hero.getAttribute('data-transition') === 'fade';
    function go(i) {
      current = (i + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (s, j) { s.classList.toggle('is-active', j === current); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === current); });
      if (!isFade) track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }
    function play() {
      if (hero.getAttribute('data-autoplay') !== 'true' || reducedMotion) return;
      timer = setInterval(function () { go(current + 1); }, parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 6000);
    }
    function pause() { clearInterval(timer); }
    var p = $('[data-hero-prev]', hero), n = $('[data-hero-next]', hero);
    if (p) p.addEventListener('click', function () { pause(); go(current - 1); play(); });
    if (n) n.addEventListener('click', function () { pause(); go(current + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { pause(); go(parseInt(d.getAttribute('data-hero-dot'), 10)); play(); }); });
    if (hero.getAttribute('data-pause-hover') === 'true') {
      hero.addEventListener('mouseenter', pause);
      hero.addEventListener('mouseleave', play);
    }
    /* Touch swipe */
    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { pause(); go(current + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    }, { passive: true });
    go(0); play();
  });

  /* ---------- Reveal on scroll ---------- */
  if (settings.animationsEnabled !== false && !reducedMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  } else {
    document.body.classList.add('no-animations');
  }

  /* ---------- Modal ---------- */
  var Modal = {
    el: null,
    init: function () {
      this.el = $('[data-quick-add-modal]');
      if (!this.el) return;
      var self = this;
      this.el.addEventListener('click', function (e) { if (e.target === self.el) self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
    },
    open: function () { if (this.el) { this.el.classList.add('is-open'); document.body.classList.add('drawer-open'); } },
    close: function () { if (this.el) { this.el.classList.remove('is-open'); document.body.classList.remove('drawer-open'); } }
  };
  Modal.init();

  /* ---------- Quick add ---------- */
  var QuickAdd = {
    open: function (handle) {
      if (!handle) return;
      var body = $('[data-quick-add-body]', Modal.el);
      if (!body) { window.location.href = '/products/' + handle; return; }
      Modal.open();
      body.innerHTML = '<div class="quick-add__loading"><span class="spinner"></span></div>';
      fetch('/products/' + handle + '?section_id=quick-add')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-quick-add-product]');
          if (!content) { window.location.href = '/products/' + handle; return; }
          body.innerHTML = '';
          body.appendChild(content);
          QuickAdd.wire(content, handle);
        })
        .catch(function () { window.location.href = '/products/' + handle; });
    },
    setLabel: function (submit, text) {
      var label = $('.quick-add-primary__label', submit);
      if (label) label.textContent = text; else submit.textContent = text;
    },
    wire: function (root, handle) {
      var form = $('[data-quick-add-form]', root);
      var variantsEl = $('[data-product-variants]', root);
      if (!form) return;
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
      var image = $('[data-quick-add-image]', root);

      form.addEventListener('change', function () {
        var selected = [];
        $$('input[type="radio"]:checked', form).forEach(function (r) { selected.push(r.value); });
        var match = variants.filter(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        })[0] || (variants.length === 1 ? variants[0] : null);
        var idInput = $('[data-variant-id]', form);
        var submit = $('[data-quick-add-submit]', form);
        var price = $('[data-quick-add-price]', root);
        var compare = $('[data-quick-add-compare]', root);
        var save = $('[data-quick-add-save]', root);
        if (match) {
          idInput.value = match.id;
          if (price) price.textContent = formatMoney(match.price);
          var onSale = match.compare_at_price && match.compare_at_price > match.price;
          if (compare) {
            compare.hidden = !onSale;
            compare.textContent = onSale ? formatMoney(match.compare_at_price) : '';
          }
          if (save) {
            save.hidden = !onSale;
            if (onSale) save.textContent = 'Save ' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
          }
          if (image && match.featured_image && match.featured_image.src && image.getAttribute('src') !== match.featured_image.src) {
            image.classList.add('is-swapping');
            var next = new Image();
            next.onload = function () { image.src = match.featured_image.src; image.removeAttribute('srcset'); image.classList.remove('is-swapping'); };
            next.onerror = function () { image.classList.remove('is-swapping'); };
            next.src = match.featured_image.src;
          }
          submit.disabled = !match.available;
          QuickAdd.setLabel(submit, match.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out'));
        } else {
          submit.disabled = true;
          QuickAdd.setLabel(submit, strings.unavailable || 'Unavailable');
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submit = $('[data-quick-add-submit]', form);
        var id = parseInt($('[data-variant-id]', form).value, 10);
        if (!id || submit.disabled) return;
        var original = ($('.quick-add-primary__label', submit) || submit).textContent;
        submit.disabled = true;
        submit.classList.add('is-loading');
        CartAPI.add(id, 1, function (err) {
          submit.classList.remove('is-loading');
          if (err) { submit.disabled = false; return; }
          submit.classList.add('is-added');
          QuickAdd.setLabel(submit, (strings.addedToCart || 'Added to cart') + ' \u2713');
          window.setTimeout(function () {
            Modal.close();
            window.setTimeout(function () {
              submit.classList.remove('is-added');
              submit.disabled = false;
              QuickAdd.setLabel(submit, original);
            }, 400);
          }, 650);
        });
      });
    }
  };

  /* ---------- Product page: variants + sticky ATC ---------- */
  var productSection = $('[data-product-section]');
  if (productSection) {
    var jsonEl = $('[data-product-json]', productSection.parentElement) || $('[data-product-json]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) {}
    var form = $('[data-product-main-form]');
    if (product && form) {
      var picker = $('[data-variant-picker]', productSection);
      var priceBox = $('[data-product-price]', productSection);
      var atc = $('[data-atc-button]', form);
      var atcText = $('[data-atc-text]', form);
      var stickyPrice = $('[data-sticky-price]');
      var stickyBtn = $('[data-sticky-atc-button]');
      var mediaItems = $$('[data-media-id]', productSection);

      function currentVariant() {
        var selected = [];
        $$('input[type="radio"]:checked', productSection).forEach(function (r) { selected.push(r.value); });
        if (!selected.length) return product.variants[0];
        return product.variants.filter(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        })[0] || null;
      }
      function refresh() {
        var v = currentVariant();
        var idInput = $('[data-variant-id]', form);
        if (!v) {
          atc.disabled = true; atcText.textContent = strings.unavailable || 'Unavailable';
          if (stickyBtn) stickyBtn.disabled = true;
          return;
        }
        idInput.value = v.id;
        var html = '<div class="price' + (v.compare_at_price > v.price ? ' price--on-sale' : '') + '"><span class="price__regular">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
        html += '</div>';
        if (priceBox) priceBox.innerHTML = html;
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        atc.disabled = !v.available;
        atcText.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
        if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = atcText.textContent; }
        /* selected option labels */
        if (picker) {
          v.options.forEach(function (opt, i) {
            var lbl = $('[data-selected-option-' + (i + 1) + ']', picker);
            if (lbl) lbl.textContent = opt;
          });
        }
        /* jump to variant media */
        if (v.featured_media && window.innerWidth < 750) {
          var target = mediaItems.filter(function (m) { return parseInt(m.getAttribute('data-media-id'), 10) === v.featured_media.id; })[0];
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        /* URL */
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (picker) picker.addEventListener('change', refresh);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = parseInt($('[data-variant-id]', form).value, 10);
        var qty = parseInt($('[data-qty-input]', form).value, 10) || 1;
        atc.disabled = true;
        CartAPI.add(id, qty, function () { atc.disabled = false; });
      });
      if (stickyBtn) stickyBtn.addEventListener('click', function () { form.requestSubmit(); });
    }

    /* Sticky bar visibility */
    var sticky = $('[data-sticky-atc]');
    var buyBox = $('[data-product-form]', productSection);
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      so.observe(buyBox);
    }
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var Wishlist = {
    key: 'vision-wishlist',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    set: function (arr) { try { localStorage.setItem(this.key, JSON.stringify(arr)); } catch (e) {} },
    toggle: function (handle, btn) {
      var list = this.get();
      var i = list.indexOf(handle);
      if (i > -1) { list.splice(i, 1); if (btn) { btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); } }
      else { list.push(handle); if (btn) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); } toast('Saved to wishlist'); }
      this.set(list);
    },
    hydrate: function () {
      var list = this.get();
      $$('[data-wishlist-toggle]').forEach(function (b) {
        if (list.indexOf(b.getAttribute('data-handle')) > -1) { b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); }
      });
    }
  };
  Wishlist.hydrate();

  /* ---------- Product recommendations (lazy) ---------- */
  $$('[data-product-recommendations]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url) return;
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { rio.disconnect(); load(); }
      }, { rootMargin: '200px' });
      rio.observe(section);
    } else { load(); }
    function load() {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-product-recommendations] .page-container');
          if (inner && inner.innerHTML.trim()) section.querySelector('.page-container').innerHTML = inner.innerHTML;
          Wishlist.hydrate();
        })
        .catch(function () {});
    }
  });
})();
